export default {
  NAME: 'name',
  REGISTRY_CODE: 'registryCode',
  KMKR_CODE: 'kmkr',
  BANK_ACCOUNT: 'bankAccountNumber',
};
